import { render, staticRenderFns } from "./CardChartPillarSummary.vue?vue&type=template&id=4bc97d52&scoped=true&"
import script from "./CardChartPillarSummary.vue?vue&type=script&lang=js&"
export * from "./CardChartPillarSummary.vue?vue&type=script&lang=js&"
import style0 from "./CardChartPillarSummary.vue?vue&type=style&index=0&id=4bc97d52&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc97d52",
  null
  
)

export default component.exports